import React, { Component, Fragment } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { getTicketTypes, reloadTickets, resetSelectedTickets, reloadCurrentTickets } from '../store/tickets';
import { isValidCard, clearCard } from '../store/cards';
import { toggleCardsList, toggleCardsListClose, showCards, hideModal, showModal } from '../store/ui';
import { cancelOrder } from "../store/order";

import TicketCategory from '../components/TicketCategory';
import Modal from '../components/Modal'
import { CautionIcon } from '../components/Icons';
import Loader from '../components/Loader';
import Return from '../components/Return';
import PromoCardButton from '../components/PromoCardButton';
import TagManager from 'react-gtm-module';

import { maxQuantitySelector } from '../selectors';
import { formatPriceTwoDecimals } from '../helpers';
class Tickets extends Component {

  constructor(props) {
    super(props);

    this.recaptchaRef = React.createRef();
    this.state = {
      withMenu: false,
      tokenG: null,
      ocimaxMenu: false
    }
  }

  componentDidMount() {
    this.handleRecaptcha()
    this.props.resetSelectedTickets();
    this.props.handleToggleCardsListClose()

    const tagManagerArgs = {
      dataLayer: {
        item_name: this.props.showtime.movie.name,
        event: 'boletos',
        items: [{
          step: 1,
          action: "checkout"
        }]
      }
    }
    const tagManagerPageView = {
      dataLayer: {
        item_name: this.props.showtime.movie.name,
        event: "pageView",
        path: '/visSelectTickets'
      }
    }

    TagManager.dataLayer(tagManagerArgs);
    TagManager.dataLayer(tagManagerPageView);
  }

  componentDidUpdate() {
    if(!this.state.withMenu && !this.state.ocimaxMenu && this.props.tickets?.areas) {
      this.props.tickets.areas.find((area) => {
        area.tickets.forEach(item => {
          if(item.type === 'adulto-menu-clasico' || item.type === 'reducido-menu-clasico') {
            this.setState(prev => ({...prev, withMenu: true, ocimaxMenu: false}));
            return;
          }
          else if  (item.type === 'adultomenu-promo-online') {
            this.setState(prev => ({...prev, ocimaxMenu: true, withMenu: false}));
            return;
          }
        })
      });
    }
  }

  shouldComponentUpdate(prevProps) {
    if (!this.props.isMobileOrDesktop && prevProps.cardsResponse !== null && !prevProps.isLoadingCards && prevProps.continueCloseModalFolios && prevProps.cardsResponse.status_code === 0) {
      this.props.handleToggleCardsListClose();
    }
    if (Object.keys(this.props.tickets).length === 0 && !prevProps.isLoadingTickets &&
      prevProps.tickets && prevProps.tickets.session_id === this.props.tickets.session_id) {
      return false;
    }

    return true;
  }

  isJunior() {
    const { tickets } = this.props;

    return tickets.areas && tickets.areas.length > 1 ? tickets.areas.some(cat => cat.name.toLowerCase().indexOf('junior') >= 0) : false;
  }

  isSalaMix() {
    const { tickets } = this.props;

    let hasPremium = false;
    let hasTradicional = false;

    tickets.areas && tickets.areas.forEach(item => {
      if (item.name.toLowerCase() === "premium") hasPremium = true;
      if (item.name.toLowerCase() === "tradicional") hasTradicional = true;
    });

    return hasPremium && hasTradicional;
  }

  hasOnlyAdultTickets() {
    const { selectedTickets } = this.props
    if(selectedTickets) {
      const adultTickets = selectedTickets.filter(({ type }) => type.toLowerCase().includes("adulto"))
      return selectedTickets.length === adultTickets.length
    }
  }

  isMinimumQuantityMet() {
    for(const {quantity, min_quantity} of this.props.selectedTickets) {
      if(quantity < min_quantity) return false
    }
    return true  
  }

  renderTicketTypes() {
    const { isLoadingTickets, tickets } = this.props;

    if (isLoadingTickets) return <Loader text="entradas" />;
    if (!tickets.areas) return null;

    return tickets.areas.map((area) => {
      return <TicketCategory
        key={area.code}
        area={area.code}
        name={area.name}
        types={area.tickets}
        selected={this.props.selectedTicketsTypes || 0}
        quantity={this.props.quantity}
        isJunior={this.isJunior()}
        maxQuantity={this.props.maxQuantity}
        isMix={this.isSalaMix()}
      />
    });
  }

  pushData = ({ removeCarrefour = false }) => {
    const { showtime, selectedTickets, tickets, clearCard, cityName } = this.props;
    if(removeCarrefour) clearCard();

    let products = [];
    let i = 1;
    for (let item of selectedTickets) {
      let category = '';
      let price;
      for (let areaItem of tickets.areas) {
        let area = areaItem.tickets.find(c => c.code === item.ticket_type_code);
        if (typeof area !== 'undefined') {
          category = typeof area.description !== 'undefined' ? area.description : typeof area.name !== 'undefined' ? area.name : '';
          price = area.price / 100
        }
      }

      const product = {
        item_id: i.toString() + tickets.session_id + showtime.showtimes.datetime.split('T')[1].replace(/:/g, ""),
        item_name: showtime.movie.name.replace(` ${showtime.movie.format}`,''),
        item_brand: showtime.movie.distributor,
        item_category: "boleto",
        item_category2: category,
        item_cinema: showtime.cinema.name,
        item_city: cityName,
        movie_date: showtime.showtimes.datetime.split('T')[0].replaceAll("-", " "),
        movie_time: showtime.showtimes.datetime.split('T')[1],
        item_language: showtime.movie.language,
        price: price,
        quantity: item.quantity,
        item_age: showtime.movie.rating,
        item_sala: showtime.movie.format
      };
      products.push(product);
      i++;
    }

    const tagManagerArgs = {
      dataLayer: {
        event: 'add_to_cart',
        ecommerce: {
          currency: 'EUR',
          times: new Date().toLocaleTimeString('es-MX', { hour12: false }),
          value: this.props.totalPrice,
          items: [...products]
        }
      }
    };
    TagManager.dataLayer(tagManagerArgs);
  }
  renderButton() {
    const buttonClasses = this.props.isMobileOrDesktop ? "btn btn--primary" : "btn btn--border btn--next"
    const buttonStyles = this.props.isMobileOrDesktop ? { borderRadius: '30px'} : {}

    if(this.props.quantity === 0 || !this.isMinimumQuantityMet()) {
      return (
        <button type="button" className={buttonClasses} disabled={true} style={buttonStyles}>
          SIGUIENTE
        </button>
      );
    }

    if(this.props.folio?.type === 'club-carrefour' && !this.hasOnlyAdultTickets()) {
      return (
        <button type="button" onClick={() => this.props.showModal({ 
            position: 'carrefour-message', 
            message: 'Para poder acumular saldo en tu tarjeta Carrefour, debes seleccionar el precio "adulto" de lo contrario no aplica la promoción. ¿Deseas continuar?'
         })} className={buttonClasses} style={ buttonStyles }>
          SIGUIENTE
        </button>
      );
    }

    return (
      <Link
        to="/butacas"
        onClick={() => this.pushData({ removeCarrefour: false })}
        className={buttonClasses}
        style={buttonStyles}
      >
        SIGUIENTE
      </Link>
    );
  }

  handleSelectedSeats = () => {
    this.setState({ goToPayment: true });
    this.props.removeSessionId();
    const { showtimeVistaId, cinemaVistaId, sessionId, selectedSeats } = this.props;
    this.props.requestSetSelectedSeats(cinemaVistaId, showtimeVistaId, sessionId, selectedSeats);
  }

  handleRecaptcha = () => {
    this.recaptchaRef.current.execute();
  }

  getToken = () => {
    //const tokenG = this.recaptchaRef.current.getValue();
    // if(tokenG !== ""){
    //   this.setState({tokenG: tokenG});
      if (this.props.selectedTickets.length > 0 && this.props.sessionId !== null) {
        this.props.getTicketTypes(this.props.cinemaVistaId, this.props.showtimeVistaId, this.props.reload, this.props.cinema_type, this.props.screen, this.props.sessionId);
      }
      else {
        this.props.getTicketTypes(this.props.cinemaVistaId, this.props.showtimeVistaId, this.props.reload, this.props.cinema_type, this.props.screen, this.props.sessionId);
      }
    //}
  }

  renderModals() {
    if(this.props.modal) {
      const { position, message, shouldShowCategoryMessage} = this.props.modal
      const modalClasses = `modal--tickets modal--main${this.state.withMenu ? " modal--tickets-withMenu" : ""}`
      if(position === 'tickets-message' && shouldShowCategoryMessage && message) {
        return (
          <Modal
            className={modalClasses}
            acceptText="OK, ENTENDIDO"
            accept={this.props.hideModal}
            title='IMPORTANTE'
            icon={<CautionIcon />}
            iconWidth="21px"
          >
            <p className="text">{this.props.modal.message}</p>
          </Modal>
        )
      }

      if(position === 'carrefour-message' && message) {
        return (
          <Modal
            className={modalClasses}
            title='IMPORTANTE'
            icon={<CautionIcon />}
            iconWidth="21px"
          >
            <p className="text">{this.props.modal.message}</p>
            <div className='modal--options'>
              <Link
                to="/butacas"
                onClick={() => this.pushData({ removeCarrefour: true })}
                className="btn btn--primary btn--primary-modal"
              >
                Sí, deseo continuar
              </Link>
              <button 
                onClick={this.props.hideModal}
                className='btn btn--secondary-modal'
              >
                No, gracias
              </button>
            </div>
          </Modal>
        )
      }
    }
  }

  render() {
    const { isLoadingTickets, showCardsList, isShowYelmoId, isMobileOrDesktop, tickets } = this.props;

    return (
      <>  
        <div className="return">
          <div className="container container--mid align-return">
            <a href="https://yelmocines.es/" className="text return__link">Volver</a>
            <a href="https://yelmocines.es/" className="btn btn--border btn--next btn--return-header">VOLVER</a>
          </div>
        </div>
        <div className={showCardsList ? 'prevent-interaction' : ''}>

          {!this.props.isLoggedIn && this.props.isMobileOrDesktop && isShowYelmoId && <Return to="/" />}

          <div className={`container container--mid tickets ${this.isJunior() ? 'tickets--junior' : ''} ${this.isSalaMix() ? 'tickets--sala-mix' : ''}`}>
            <h3 className="title ticket-title">Selecciona tus entradas</h3>
            {!this.props.isLoadingTickets && <p className="text">Puedes comprar {this.props.maxQuantity} entradas máximo por transacción.</p>}
            {(this.state.withMenu || this.state.ocimaxMenu) &&
              <figure>
                {this.props.isOcimax && this.state.ocimaxMenu && <img src='https://yelmocines-media.s3.eu-central-1.amazonaws.com/banners/tickets/Banner.png' onError={(ev) => ev.target.style.display = 'none'}/> }
                {!this.props.isOcimax && this.state.withMenu && <img src={require(`../static/images/promo.png`)} /> }
              </figure>
            }

            <div className="container container--small">
              <div className="ticket-container margin-to-btn">
              {(!this.props.isLoadingTickets && tickets?.areas?.length === 0) && <p className="text">Se han agotado los beneficios en tu tarjeta Movie Yelmo o no aplica para esta función y/o formato.</p>}
                {this.renderTicketTypes()}
              </div>

              {this.renderButton()}
              {(!isLoadingTickets && this.props.folio?.type !== 'club-carrefour') && <PromoCardButton hasFolio={this.props.hasFolio} toggleCards={this.props.handleToggleCardsList} />}

              {!this.props.isLoggedIn && !this.props.isMobileOrDesktop && isShowYelmoId && <Return to="/" />}
            </div>

          </div>
          <div className="container container--large tickets__rights">
          <p>
            CINE YELMO informa a sus clientes que la empresa no se hace responsable del cumplimiento o resultado de transacciones, 
            promociones y/o en general de operaciones realizadas a través de aplicaciones, 
            sitios o plataformas no oficiales de CINE YELMO. 
            Cualquier transacción realizada por otras plataformas no autorizadas no serán válidas. 
            Aplicaciones, sitios y plataformas oficiales: www.yelmocines.es y aplicaciones oficiales para iOS y Android.
            </p>
            <p>
            Los precios “REDUCIDOS” incluyen: “Senior” (personas mayores de 60 años), “Joven” (entre 13 y 30 años, y con carnet joven o de estudiante), 
            “Niño” (entre 3 y 12 años) y “Diversidad funcional” (descuento aplicable a personas con una discapacidad acreditada del 33% o superior, 
            y a uno de sus acompañantes). El precio de SENIOR 65 (personas mayores de 65 años) solo aplica los martes. </p>
            <p>
            Para hacer válidos los precios aplicables a: “Senior”, “Joven”, “Niños”, “Senior 65” y “Diversidad funcional”, 
            se deberá mostrar identificación que lo acredite. Los niños menores de 3 años no pagan si no ocupan butaca, 
            salvo en la Sala Junior donde toda persona que esté en la sala deberá contar con entrada. 
            El precio de miércoles no aplica en días festivos, ni vísperas de festivos, por lo que se aplicará el precio vigente más alto del fin de semana correspondiente a cada formato (funciones 2D, 3D). 
            En días festivos se aplica el precio vigente más alto del fin de semana correspondiente a cada formato. 
            El precio para sesiones o eventos especiales, correspondiente a cada formato (funciones 2D, 3D) será el publicado y determinado por Cine Yelmo. 
            En algunas películas no se aplican precios MovieYELMO ni precios promocionales, consultar títulos participantes en la taquilla de tu cine. Todos los precios Incluyen Impuestos. 
            Con la tarjeta MovieYELMO en web solo se podrá adquirir 2 entradas por transacción.
            </p>
            <p>
            CINE YELMO se reserva el derecho de variar, los precios de sus productos en función del horario, 
            día de la semana y/o momento de la temporada, según considere.
            </p>
          </div>
          <ReCAPTCHA
            ref={this.recaptchaRef}
            size="invisible"
            sitekey="6LcVRncgAAAAAIki4zbiiTYFCUNkbrcLAyqqxOhi"
            onChange={this.getToken}
          />
        </div>
        {this.renderModals()}
      </>
    );
  }
}

const mapStateToProps = ({ login, tickets, cards, globals, ui, showtime, seats, locations }) => {
  let isShowYelmoId = false;
  if (showtime) {
    if (showtime.settings) {
      if (showtime.settings.profile) {
        let profile = showtime.settings.profile;
        isShowYelmoId = profile.indexOf("cinepolis_id") !== -1;
      }
    }
  }

  let cityName = ''
  if(locations && locations.cities) {
    const currentCity = locations.cities.find(city => {
      const hasCurrentCinema = city?.cinemas.find(cinema => cinema.vista_id === showtime.cinema.vista_id)
      return hasCurrentCinema
    })
    cityName = currentCity?.name
  }

  return {
    quantity: Object.keys(tickets.types).length > 0 ?
      Object.keys(tickets.types).reduce((acc, key) => {
        return acc + tickets.types[key];
      }, 0)
      : 0,
      isShowYelmoId,
    maxQuantity: maxQuantitySelector(tickets),
    isLoadingTickets: tickets.isLoading,
    totalPrice: +formatPriceTwoDecimals(tickets.total),
    tickets: tickets.tickets,
    selectedTicketsTypes: tickets.types,
    selectedTickets: tickets.selectedTickets,
    folio: cards.folio,
    cardsResponse: cards.response,
    isLoadingCards: cards.isLoading,
    cardList: cards.cardList,
    continueCloseModalFolios: ui.continueToggleCardsLis,
    cinemaVistaId: globals.cinemaVistaId,
    showtimeVistaId: globals.showtimeVistaId,
    isMobile: ui.isMobile,
    windowSize: ui.size,
    showCardsList: ui.showCardsList,
    isLoggedIn: login.loginResponse !== null,
    showtime,
    sessionId: globals.sessionId,
    reload: seats.response.status_code === 0 || tickets.showtimeVistaId !== globals.showtimeVistaId,
    isMobileOrDesktop: (ui.isMobile && ui.size >= 768 && ui.size < 1024) || !ui.isMobile,
    cinema_type: showtime.movie.format,
    screen: showtime.showtimes.screen,
    hasFolio: cards.cardList.length > 0,
    modal: ui.modal,
    cityName,
    isOcimax: showtime.cinema.name.toLowerCase() === 'ocimax gijón'
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    reloadTickets: (cardsResponse) => dispatch(reloadTickets(cardsResponse)),
    resetSelectedTickets: () => dispatch(resetSelectedTickets()),
    getTicketTypes: (cinemaVistaId, showtimeVistaId, reload, cinemaType, screen, sessionId, tokenG) => dispatch(getTicketTypes(cinemaVistaId, showtimeVistaId, reload, cinemaType, screen, sessionId, tokenG)),
    isValidCard: (folio, setTicketLoader) => dispatch(isValidCard(folio, setTicketLoader)),
    handleToggleCardsList: () => {
      dispatch(toggleCardsList());
    },
    handleToggleCardsListClose: () => {
      dispatch(toggleCardsListClose());
    },
    reloadCurrentTickets: () => dispatch(reloadCurrentTickets()),
    cancelOrder: (sessionId, resetSession) =>
      dispatch(cancelOrder(sessionId, resetSession)),
    hideModal: () => dispatch(hideModal()),
    showModal: (obj) => dispatch(showModal(obj)),
    clearCard: () => dispatch(clearCard())
    
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Tickets);
